import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  sidebarContact: {
    opacity: 0.4,
    transition: 'opacity 0.5s',
    padding: theme.spacing(0, 4, 3),
    h6: {
      fontWeight: 'normal'
    },
    svg: {
      marginRight: theme.spacing(1),
      color: 'white',
      opacity: 0.2
    },
    a: {
      marginLeft: theme.spacing(-1),
      color: theme.vars.palette.primary.light,
      fontSize: '1rem'
    },
    '&:hover': {
      opacity: 1
    },
    '&.inPopover': {
      opacity: 1,
      padding: theme.spacing(3)
    }
  },
  sidebarContactPopover: {
    backgroundColor: theme.vars.palette.background.navigation
  },
  collapsedContactButton: {
    display: 'flex',
    justifyContent: 'center',
    borderRadius: '50%',
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    height: '2.5rem',
    width: '2.5rem',
    margin: '0 auto 1rem',
    svg: {
      width: '1.25rem',
      color: 'rgba(255, 255, 255, 0.25)'
    },
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)'
    }
  }
}));

export default useStyles;
